import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000', ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M23.5 19.938a1.5 1.5 0 01-1.5 1.5H2.5a1.5 1.5 0 01-1.5-1.5v-10.5a1.5 1.5 0 011.5-1.5H22a1.5 1.5 0 011.5 1.5v10.5zm-21 0H22v-10.5H2.5v10.5z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M12.25 16.938a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zm3.75-2.25a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM8.314 21.181a.75.75 0 01-1.058.07l-6-5.25a.75.75 0 11.988-1.128l6 5.25a.75.75 0 01.07 1.058z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M1.186 14.431a.75.75 0 01.07-1.058l6-5.25a.75.75 0 11.988 1.129l-6 5.25a.75.75 0 01-1.058-.07zM16.186 21.181a.75.75 0 01.07-1.058l6-5.25a.75.75 0 11.988 1.129l-6 5.25a.75.75 0 01-1.058-.07z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M23.314 14.431a.75.75 0 01-1.058.07l-6-5.25a.75.75 0 01.988-1.128l6 5.25a.75.75 0 01.07 1.058zM12.25 9.688a.75.75 0 01-.75-.75V2.75a.75.75 0 011.5 0v6.188a.75.75 0 01-.75.75z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M15.312 5.812a.75.75 0 01-1.061 0L12.25 3.81l-2 2a.75.75 0 01-1.062-1.06L11.72 2.22a.75.75 0 011.06 0l2.532 2.53a.75.75 0 010 1.062z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
